module.exports = __webpack_public_path__ + "static/media/21ECLAC3.a89e04b2.jpg";